import { Stack } from 'expo-router';

export default function GymLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
